import { apiClient } from './api';

export interface Category {
  id: number;
  name: string;
  description: string | null;
  parent_id: number | null;
  is_active: boolean;
  sku_count: number;
  total_stock: number;
  total_revenue: number;
  avg_margin: number;
  created_at: string;
  updated_at: string;
}

export interface CategoryInput {
  name: string;
  description?: string;
  parent_id?: number | null;
  is_active?: boolean;
}

export async function listCategories(): Promise<Category[]> {
  const raw = await apiClient.get<{ data: Category[] }>('/categories');
  return raw.data ?? (raw as any);
}

export async function getCategory(id: number | string): Promise<Category> {
  return apiClient.get<Category>(`/categories/${id}`);
}

export async function createCategory(input: CategoryInput): Promise<Category> {
  return apiClient.post<Category>('/categories', input);
}

export async function updateCategory(id: number | string, input: Partial<CategoryInput>): Promise<Category> {
  return apiClient.patch<Category>(`/categories/${id}`, input);
}

export async function deleteCategory(id: number | string): Promise<void> {
  await apiClient.delete<void>(`/categories/${id}`);
}
